// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1lk9M","footer":"ModalUpdate_footer__3Lb1i"};